module.exports = __webpack_public_path__ + "img/table-arrival-icon.a16165d2.svg";